import styled from '@emotion/styled'
import { Button, Typography } from '@mui/material'
import React from 'react'

import { useImageGalleryContext } from '@f-fertighaus/applications/Next/components/common/ImageGallery/ImageGalleryContext'
import { LandscapeIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/LandscapeIcon'
import { useDeviceWidth } from '@f-fertighaus/applications/Next/hooks/useDeviceWidth'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { ImagesTab } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseImageGallery/HouseImageGallery'

export const FloorPlansButton = () => {
  const { dispatch } = useImageGalleryContext()
  const { isMobile } = useDeviceWidth()

  const handleClick = () => {
    window?._wt({
      category: 'CTA-button',
      action: 'click',
      label: 'view-pictures-floor-plans',
      location: isMobile ? 'image-carousel' : 'image-tiles',
      values: [
        { type: 'text', value: t('houseDetailPage.pictures_and_floor_plans') }
      ]
    })

    dispatch({
      type: 'openGallery',
      initialTabIndex: ImagesTab.houseImages
    })
  }

  return (
    <StyledButton onClick={handleClick}>
      <LandscapeIcon />
      <Typography variant='caption' sx={{ paddingLeft: 1 }}>
        {t('houseDetailPage.pictures_and_floor_plans')}
      </Typography>
    </StyledButton>
  )
}

const StyledButton = styled(Button)`
  position: absolute;

  z-index: 2;
  background-color: ${({ theme }) => theme.palette.background.paper};
  text-transform: none;
  box-shadow: 0 5px 10px -1px rgb(59 71 104 / 5%), 0 2px 4px -3px #3b4768,
    0 2px 40px 0 rgb(59 71 104 / 5%);
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary.main};
  }
  &:hover {
    background-color: ${({ theme }) => theme.palette.background.paper};
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    left: ${({ theme }) => theme.spacing(1)};
    bottom: ${({ theme }) => theme.spacing(2)};
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    top: ${({ theme }) => theme.spacing(2)};
    left: ${({ theme }) => theme.spacing(2)};
  }
`
